export default "__VITE_ASSET__Tt6Nc56l__"